import { render } from "./CreateSiteStep2.vue?vue&type=template&id=32962a1b&scoped=true"
import script from "./CreateSiteStep2.vue?vue&type=script&lang=js"
export * from "./CreateSiteStep2.vue?vue&type=script&lang=js"

import "./CreateSiteStep2.vue?vue&type=style&index=0&id=32962a1b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32962a1b"]])

export default __exports__